var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmailCircle = function SvgEmailCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#DB5437"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#fff",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.134 15.865H15.867c-2.493 0-4.51 2.04-4.51 4.534l-.023 27.2a4.547 4.547 0 004.533 4.533h36.267a4.547 4.547 0 004.533-4.533v-27.2a4.547 4.547 0 00-4.533-4.534zm0 9.067L34 36.265 15.867 24.932v-4.533L34 31.732l18.134-11.333v4.533z",
    fill: "#DB5437"
  })));
};
export default SvgEmailCircle;